"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable class-methods-use-this */
const axios_1 = __importDefault(require("axios"));
const BaseBuyProvider_1 = require("../BaseBuyProvider");
const cryptos_1 = __importDefault(require("./cryptos"));
const fiats_1 = __importDefault(require("./fiats"));
const countries_1 = __importDefault(require("./countries"));
const mercuryo_svg_1 = __importDefault(require("../../../../static/providers/mercuryo.svg"));
// import { MERCURYO_WIDGET_BUY_ID } from "../../data/apiKeys";
const constants_1 = require("./constants");
const paymentOptions_1 = __importDefault(require("./paymentOptions"));
const fiatRates_1 = require("../../helpers/fiatRates");
// import { convertFiatRate } from "../../helpers/fiatRates";
const MERCURYO_BASE_API = process.env.DEPLOY_ENV === "production"
    ? constants_1.MERCURYO_API_PROD
    : constants_1.MERCURYO_API_PROD;
/* const MERCURYO_WIDGET_ID =
  process.env.DEPLOY_ENV === "production"
    ? MERCURYO_WIDGET_BUY_ID
    : MERCURYO_WIDGET_BUY_ID; */
/* const axiosConfig = {
  params: {
    widget_id: MERCURYO_WIDGET_ID,
  },
}; */
class MercuryoProvider {
    constructor() {
        this.id = "mercuryo";
        this.name = "Mercuryo";
        this.logo = mercuryo_svg_1.default;
        this.addressPassthrough = true;
        this.countries = [];
        this.fiats = [];
        this.cryptos = [];
        this.defaultFiatCurrency = "USD";
    }
    fetchCountries() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const url = `${MERCURYO_BASE_API}${constants_1.MERCURYO_ENDPOINTS.COUNTRIES}`;
                const { data } = yield axios_1.default.get(url);
                this.countries = data.data.map((i) => i.toUpperCase());
            }
            catch (error) {
                console.log("Error fetching Mercuryo countries, using fallback", error);
                this.countries = countries_1.default.map((i) => i.toUpperCase());
            }
        });
    }
    fetchCurrencies() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const url = `${MERCURYO_BASE_API}${constants_1.MERCURYO_ENDPOINTS.CURRENCIES}`;
                const { data } = yield axios_1.default.get(url);
                this.fiats = data.data.fiat;
                this.cryptos = data.data.crypto;
            }
            catch (error) {
                console.log("Error fetching Mercuryo currencies, using fallback", error);
                this.fiats = fiats_1.default;
                this.cryptos = cryptos_1.default;
            }
        });
    }
    /* private async fetchLimits(
      from: string,
      to: string,
      type: "buy" | "sell"
    ): Promise<{ min: number; max: number } | undefined> {
      try {
        const url = `${MERCURYO_BASE_API}${MERCURYO_ENDPOINTS.LIMITS}`;
        const {
          data: { data },
        } = await axios.get<MercuryoLimitsReponse>(url, {
          params: {
            from,
            to,
            type,
            widget_id: MERCURYO_WIDGET_ID,
          },
        });
  
        return {
          min: Number(data[from].min),
          max: Number(data[from].max),
        };
      } catch (error) {
        console.log("Error getting Mercuryo limits", error);
        return undefined;
      }
    } */
    getPaymentMethods() {
        return __awaiter(this, void 0, void 0, function* () {
            return paymentOptions_1.default;
        });
    }
    getAvailability(countryData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!countryData)
                return false;
            if (this.countries.length === 0) {
                yield this.fetchCountries();
            }
            return this.countries.includes(countryData.alpha3.toUpperCase());
        });
    }
    getSupportedCryptos() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.cryptos.length === 0) {
                yield this.fetchCurrencies();
            }
            return this.cryptos;
        });
    }
    getSupportedFiat() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.fiats.length === 0) {
                yield this.fetchCurrencies();
            }
            return this.fiats;
        });
    }
    getSupportedCountries() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.countries.length === 0) {
                yield this.fetchCountries();
            }
            return this.countries;
        });
    }
    getBuyQuote(cryptoCode, fiatCode, fiatAmount) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const paymentOptions = yield this.getPaymentMethods();
                const isRequestedCurrency = (yield this.getSupportedFiat()).includes(fiatCode);
                const currencyCode = isRequestedCurrency
                    ? fiatCode.toUpperCase()
                    : this.defaultFiatCurrency;
                const convertedRate = isRequestedCurrency
                    ? fiatAmount
                    : Math.ceil(yield (0, fiatRates_1.convertFiatRate)(currencyCode, fiatCode, fiatAmount));
                const responseData = {
                    cryptoAmount: -1,
                    fiatAmount: convertedRate,
                    provider: this.id,
                    rate: -1,
                    isRequestedCurrency,
                    paymentOptions,
                    fiatCode: currencyCode,
                };
                return responseData;
            }
            catch (error) {
                console.log("Mercuryo Error", error);
                return BaseBuyProvider_1.DEFAULT_ERROR;
            }
        });
    }
    getSellQuote(cryptoCode, fiatCode, cryptoAmount
    // geoLocation?: CountryDataType | undefined
    ) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const isRequestedCurrency = (yield this.getSupportedFiat()).includes(fiatCode);
                const currencyCode = isRequestedCurrency
                    ? fiatCode
                    : this.defaultFiatCurrency;
                const responseData = {
                    provider: this.id,
                    cryptoAmount,
                    fiatAmount: -1,
                    fiatCode: currencyCode,
                    isRequestedCurrency,
                    rate: -1,
                };
                return responseData;
            }
            catch (error) {
                console.log("Error getting Mercuryo Sell quote", error);
                return BaseBuyProvider_1.DEFAULT_ERROR;
            }
        });
    }
}
exports.default = MercuryoProvider;
//# sourceMappingURL=Mercuryo.js.map